// Pure helpers for placing a product within its category column. The board shows
// products by stored display_order then name; the editor lets keyboard users set
// a 1-based "position in category" that we translate into a batch reorder payload
// (the accessible equivalent of dragging the card). No React here — easy to test.

// Board order: by stored display_order, then name (mirrors the kanban columns).
export const byOrder = (a, b) => (a.display_order - b.display_order)
  || a.name.localeCompare(b.name);

// Products in a category, in the order the board shows them.
export const siblingsInCategory = (products, categoryId) => products
  .filter((product) => product.category_id === Number(categoryId))
  .sort(byOrder);

// 1-based slot a product currently occupies in its column (or the end slot for a
// product that isn't in the list yet, e.g. a brand-new one).
export const positionInCategory = (products, categoryId, productId) => {
  const siblings = siblingsInCategory(products, categoryId);
  const index = productId == null
    ? siblings.length
    : siblings.findIndex((product) => product.id === productId);
  return (index < 0 ? siblings.length : index) + 1;
};

// Build a batch-reorder payload that inserts `savedItem` at the requested 1-based
// `position` among its (renumbered) siblings in `categoryId`. Renumbers every
// affected product so display_order stays contiguous.
export const placementPayload = (products, savedItem, categoryId, position) => {
  const catId = Number(categoryId);
  const others = products
    .filter((product) => product.category_id === catId && product.id !== savedItem.id)
    .sort(byOrder);
  const desired = Number(position) || others.length + 1;
  const insertIdx = Math.min(Math.max(desired - 1, 0), others.length);
  const ordered = [...others.slice(0, insertIdx), savedItem, ...others.slice(insertIdx)];
  return {
    categories: [],
    products: ordered.map((product, i) => ({
      id: product.id, display_order: i, category_id: catId,
    })),
  };
};
